import useTracker from 'common/utils/user-tracker/useTracker';

function View() {
  useTracker({ pageId: 'resetPasswordSuccess' });
}

export default View;
